import React from "react"
import { useTranslation } from "react-i18next"
import { Box, Image, Typography } from "src/UILibrary"
import { useMediaQuery } from "react-responsive"
import { NEWS_INTERVIEW_TYPES_STRING } from "src/modules/const"
import { News } from "src/openapi"
import { useNavigate } from "react-router-dom"

type Props = {
  item?: News
}

export const NewsDetailItem = ({ item }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "news" })
  const isTablet = useMediaQuery({ query: "(min-width: 900px)" })
  const navigate = useNavigate()

  const extractDate = (date?: string) => {
    let ret
    if (!date) return ""
    ret = date.replaceAll("-", "/")
    return ret.substring(0, 10)
  }

  return (
    <Box sx={{ p: isTablet ? "10px 10px" : "10px 0px" }}>
      <Image
        src={item?.imageUrl!}
        alt=""
        sx={{
          height: 225,
          bgcolor: "divider",
          flex: 1,
          ":hover": { opacity: 0.8, cursor: "pointer" },
        }}
        imageStyle={{ width: "100%", height: "100%" }}
        onClick={() => {
          navigate(`/news/${item?.id}`)
          //navigate(0)
        }}
      />
      <Box sx={{ p: isTablet ? "20px" : "20px 0px" }}>
        <Box display="flex" sx={{ mb: isTablet ? "20px" : "10px" }} alignItems="center">
          <Typography.Action
            color="textPrimary"
            className="notosans weight500"
            sx={{
              borderRadius: 0,
              border: "1px solid",
              borderColor: "text.primary",
              lineHeight: "1.25rem",
              px: "0.625rem",
              mr: "auto",
            }}
          >
            {item?.type == NEWS_INTERVIEW_TYPES_STRING.NEWS ? t("news") : t("interview")}
          </Typography.Action>
          <Typography.Description className="notosans weight500 grey" lineHeight={1.25} mr={1.25}>
            {extractDate(item?.createdAt)}
          </Typography.Description>
        </Box>
        <Typography.SubTitle
          color="textPrimary"
          className="notosans weight500 restrict_line"
          lineHeight={1}
          sx={{
            ":hover": { opacity: 0.8, cursor: "pointer" },
          }}
          onClick={() => navigate(`/news/${item?.id}`)}
        >
          {item?.title}
        </Typography.SubTitle>
      </Box>
    </Box>
  )
}
